import cx from "classnames";
import React, { PropsWithChildren, useEffect, useRef, useState } from "react";

import styles from "./Collapsible.mscss";

interface OwnProps {
    className?: string;
    collapsed?: boolean;
    height?: number;
    maxHeight?: number;
}

type Props = OwnProps;

const Collapsible: React.FunctionComponent<Props> = ({
    className,
    collapsed = false,
    height = 0,
    maxHeight,
    children,
}) => {
    const [computedMaxHeight, setComputedMaxHeight] = useState<number>(0);
    const containerRef = useRef<HTMLDivElement>();

    useEffect(() => {
        if (!maxHeight) {
            const computedHeight = Array.from(containerRef.current.children).reduce((acc, cur) => {
                const computed = window.getComputedStyle(cur);
                const elementHeight = parseFloat(computed.height);
                const margins = parseFloat(computed.marginTop) + parseFloat(computed.marginBottom);
                return acc + elementHeight + margins;
            }, 0);
            setComputedMaxHeight(computedHeight);
        }
    }, [children, maxHeight]);

    return (
        <div
            className={cx(styles.Collapsible, className)}
            style={{ maxHeight: collapsed ? height : maxHeight || computedMaxHeight }}
            ref={containerRef}
        >
            {children}
        </div>
    );
};

Collapsible.displayName = "Collapsible";

export default React.memo<PropsWithChildren<Props>>(Collapsible);
